import clsx from "clsx";
import type { ComponentProps, ReactNode } from "react";

import type { FilterItemType } from "@shared/content-types/types";

import { FilterToggle } from "../filter-toggle";
import { Filters } from "../filters";

import s from "./filters-with-boolean.module.scss";

export interface FiltersWithBooleanProps extends ComponentProps<"div"> {
  className?: string;
  filters: FilterItemType[];
  onChangeFilter: (filter: string) => void;
  booleanFilter: boolean;
  onBooleanFilterChange: (value: boolean) => void;
  booleanLabel: string;
  hasAllItem?: boolean;
  dropdownFieldLabel?: string;
  children?: ReactNode;
}

export const FiltersWithBoolean = (props: FiltersWithBooleanProps) => {
  const {
    className,
    filters,
    onChangeFilter,
    booleanFilter,
    onBooleanFilterChange,
    booleanLabel,
    hasAllItem = true,
    dropdownFieldLabel,
    children,
  } = props;

  return (
    <div className={clsx(s.root, className)}>
      <Filters
        filters={filters}
        onChangeFilter={onChangeFilter}
        hasAllItem={hasAllItem}
        dropdownFieldLabel={dropdownFieldLabel}
        className={s.filters}
      />
      <div className={s.toggleGroup}>
        <FilterToggle
          className={s.toggle}
          isActive={booleanFilter}
          onClick={() => onBooleanFilterChange(!booleanFilter)}
          label={booleanLabel}
          variant="default"
        />
        {children}
      </div>
    </div>
  );
};
